import { useAtomValue } from "jotai";
import { useRouter } from "next/router";
import { useContext } from "react";

import ButtonV2 from "@/components/shared/buttonV2";
import Modal from "@/components/shared/modal";
import { autoCompeleteSelectFlag } from "@/states/owner/task/autoCompeleteSelectAtom";
import { TaskContext } from "contexts/task";
import { ApplyFilter } from "@/types/owner/task/applyFilter";

type Props = {
  showModal: boolean;
  setShowModal: React.Dispatch<React.SetStateAction<boolean>>;
  setApplyFilter?: React.Dispatch<React.SetStateAction<ApplyFilter>>;
  changeFilter?: (
    type: string,
    autoCompeleteSelect: boolean,
    tab: string
  ) => Promise<any>;
  isRatingBulk?: boolean; // 一括確認の場合はtrue
};

/* 評価時エラー表示用モーダル */
const RatingErrorModal: React.FC<Props> = ({
  showModal,
  setShowModal,
  setApplyFilter,
  changeFilter,
  isRatingBulk
}) => {
  const { ownerFilterList, setOwnerFilterList } = useContext(TaskContext);
  const autoCompeleteSelect = useAtomValue(autoCompeleteSelectFlag);
  const router = useRouter();
  const { tab } = router.query;

  //登録一覧画面に戻る
  const backToTaskTab = () => {
    if (isRatingBulk) {
      setOwnerFilterList({
        ...ownerFilterList,
        statusId: [1],
        tab: "waiting",
        suggestion: "なし",
        page: 1,
        rejectedOnly: 1
      });
      //フィルタ再実行
      if (changeFilter && setApplyFilter) {
        setApplyFilter("filter");
      }
    } else {
      router.push(`/owner/task?tab=task`);
    }
  };

  return (
    <Modal
      show={showModal}
      title={
        isRatingBulk
          ? "確認一括完了できませんでした"
          : "確認完了できませんでした"
      }
      showClose
      titleRed
      setShow={setShowModal}
    >
      <div className="p-16 pt-0 text-md leading-9">
        {isRatingBulk ? (
          <p>
            クルーにより取り下げられた報告があります。
            もう一度、確認一括完了を実行してください。
          </p>
        ) : (
          <p>クルーにより報告が取り下げられました。</p>
        )}
        <p>
          取り下げられた仕事は予定タブで「再提出待ち」になります。クルーからの再提出をお待ちください。
        </p>
        <div className="mt-10 flex flex-col gap-8">
          <ButtonV2
            variant="primary"
            layout="fullWidth"
            click={() => {
              setShowModal(false);
              backToTaskTab();
            }}
          >
            {isRatingBulk ? "再提出待ちを確認する" : "閉じる"}
          </ButtonV2>
          {isRatingBulk && (
            <ButtonV2
              variant="primaryOutline"
              layout="fullWidth"
              click={async () => {
                //フィルタ再実行
                if (changeFilter) {
                  await changeFilter(
                    "filter",
                    autoCompeleteSelect,
                    tab as string
                  );
                }
                setShowModal(false);
              }}
            >
              閉じる
            </ButtonV2>
          )}
        </div>
      </div>
    </Modal>
  );
};

export default RatingErrorModal;
